export default function abbreviateNumber(value: number) {
  let newValue = value;
  const suffixes = ["", "k", "m"];
  let suffixNum = 0;
  while (newValue >= 1000) {
    newValue /= 1000;
    suffixNum++;
  }

  let result = parseFloat(newValue.toPrecision(3)).toString();

  result += suffixes[suffixNum];

  return result;
}
